<template>
  <div class="login-bg">
    <div class="login-left">
      <img class="login-left-img" src="../../../public/static/login/loginImg.jpg">
    </div>
    <div class="login-right">
      <div class="login-top-left"></div>
      <div class="login-top-right"></div>
      <div class="login-bottom-left"></div>
      <div class="login-bottom-right"></div>
      <div class="login-left-left"></div>
      <div class="login-top-top"></div>
      <div class="login-right-right"></div>
      <div class="login-bottom-bottom"></div>
      <div class="login-right-box">
        <a-form>
          <h2>Dolphin后台管理系统</h2>
          <p>Dolphin Framework System</p>
          <a-form-item style="margin-bottom:24px;">
            <a-input v-model:value.trim="loginForm.username" class="login-item" placeholder="请输入用户名"
                     @pressEnter="login">
              <template #prefix>
                <dol-icon type="user-outlined" />
              </template>
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input-password v-model:value.trim="loginForm.password" class="login-item" type="password" placeholder="请输入密码"
                     @pressEnter="login">
              <template #prefix>
                <lock-outlined />
              </template>
            </a-input-password>
          </a-form-item>
<!--          <a-form-item>-->
<!--            <a-row>-->
<!--              <a-col :span="12">-->
<!--                <a-checkbox v-model:checked="loginForm.autoLoginFlag" class="login-item-bottom">-->
<!--                  7天内自动登录-->
<!--                </a-checkbox>-->
<!--              </a-col>-->
<!--              <a-col :span="12">-->
<!--                <a class="login-item-bottom-right">-->
<!--                  忘记密码-->
<!--                </a>-->
<!--              </a-col>-->
<!--            </a-row>-->
<!--          </a-form-item>-->
          <a-form-item>
            <a-button class="login-button" :loading="loading" block @click="login">
              登录
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import { UserOutlined, LockOutlined, SafetyCertificateOutlined } from '@ant-design/icons-vue';
import { getCurrentInstance } from 'vue';

export default {
  name: 'login',
  components: { UserOutlined, LockOutlined, SafetyCertificateOutlined },
  data() {
    return {
      testStr: '123',

      loginForm: {
        username: 'dolphin',
        password: 'dolphin123',
        type: 'username', //username | phone
        autoLoginFlag: true,
      },

      loading: false,
    };
  },
  computed: {},
  methods: {
    login() {
      this.loading = true;
      this.$store.dispatch('user/login', this.loginForm).then(() => {
        function getFirstMenu(menu){
          if(menu.children && menu.children.length > 0){
            return getFirstMenu(menu.children[0]);
          }else{
            return menu;
          }
        }

        let firstMenu = this.$store.state.user.menuList && this.$store.state.user.menuList[0];
        if(firstMenu){
          const menu = getFirstMenu(firstMenu);
          this.$router.replace(menu.fullPath);
        }else{
          this.$message.error('权限配置有误');
        }
      }).catch(e => {}).finally(() => {
        this.loading = false;
      });
    }
  },
  created() {
  },
};
</script>

<style lang="scss">
.login-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient( 180deg, #122875 0%, #0B1847 100%);
  display: flex;
  justify-content: center;
  align-items: center;

  .login-left {
    width: 700px;
    min-width: 700px;
    height: auto;

    .login-left-img {
      width: 100%;
      height: 100%;
    }
  }

  .login-right {
    margin-left: 10%;
    width: 426px;
    min-width: 426px;
    position: relative;

    .login-right-box {
      background: rgba(24, 55, 129, 0.5);
      box-shadow: inset 0px 0px 18px 2px rgba(86, 169, 255, 0.5);
      border: 1px solid rgba(179, 235, 255, 0.39);
      width: 100%;
      height: 100%;
      padding: 28px 48px 32px;

      h2 {
        font-weight: 600;
        color: #A1CFFF;
        font-size: 24px;
        letter-spacing: 6px;
        margin: 0;
        text-align: center;
      }

      p {
        font-weight: 600;
        color: #A1CFFF;
        font-size: 16px;
        margin-bottom: 32px;
        text-align: center;
      }

    }

    .svgCode-background {
      background-color: #FFFFFF;
      height: 48px;
      text-align: center;
      margin-left: 10px;
      border-radius: 4px;

      svg {
        width: 100px !important;
        height: 48px !important;;
      }
    }

    .login-item-bottom {
      font-size: 14px;
      font-weight: 600;
      color: #FFFFFF;
    }

    .login-button {
      background: linear-gradient(135deg, #12BDFA 0%, #0D79EB 100%);
      border-radius: 4px;
      border: none;
      color: #FFFFFF;
      height: 48px;

      &:hover {
        color: #dddddd;
      }
    }

    .login-item-bottom-right {
      text-align: right;
      font-size: 14px;
      font-weight: 600;
      color: #FFFFFF;
    }


    .login-item {
      height: 48px !important;
      background: rgba(16, 30, 71, 0.5) !important;
      border-radius: 4px !important;
      border: 1px solid #B3EBFF !important;

      &:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active {
        -webkit-transition-delay: 99999s;
        -webkit-transition: color 99999s ease-out, background-color 99999s ease-out;
      }

      input {
        background: transparent;
        color: #FFFFFF;
        padding-left: 5px;
      }

      .ant-input-prefix {
        color: #FFFFFF;
        font-size: 16px;
      }
    }

    .login-top-left {
      position: absolute;
      top: 0;
      left: 0;
      width: 24px;
      height: 24px;
      border-left: 4px solid #A1CFFF;
      border-top: 4px solid #A1CFFF;
    }

    .login-top-right {
      position: absolute;
      top: 0;
      right: 0;
      width: 24px;
      height: 24px;
      border-right: 4px solid #A1CFFF;
      border-top: 4px solid #A1CFFF;
    }

    .login-bottom-left {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 24px;
      height: 24px;
      border-left: 4px solid #A1CFFF;
      border-bottom: 4px solid #A1CFFF;
    }

    .login-bottom-right {
      position: absolute;
      bottom: 0;
      right: 0;
      width: 24px;
      height: 24px;
      border-right: 4px solid #A1CFFF;
      border-bottom: 4px solid #A1CFFF;
    }

    .login-left-left {
      height: 60%;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      border: 1px solid;
      border-image: radial-gradient(circle, rgba(161, 207, 255, 1), rgba(255, 255, 255, 0)) 2 2;
    }

    .login-bottom-bottom {
      width: 60%;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      border: 1px solid;
      border-image: radial-gradient(circle, rgba(161, 207, 255, 1), rgba(255, 255, 255, 0)) 2 2;
    }

    .login-top-top {
      width: 60%;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      border: 1px solid;
      border-image: radial-gradient(circle, rgba(161, 207, 255, 1), rgba(255, 255, 255, 0)) 2 2;
    }

    .login-right-right {
      height: 60%;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      border: 1px solid;
      border-image: radial-gradient(circle, rgba(161, 207, 255, 1), rgba(255, 255, 255, 0)) 2 2;
    }
  }
}
</style>
